import styled from 'styled-components';

interface ProcedureFormatProps {
  children: React.ReactNode;
  className?: string;
}

export const ProcedureStyle = styled.ol`
  list-style: none;
  counter-reset: counter;
  padding: 0;
  margin: 0;
`;

export const ProcedureFormat = (props: ProcedureFormatProps) => {
  const { className, children } = props;

  return <ProcedureStyle className={className}>{children}</ProcedureStyle>;
};
